import React from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import { experience } from "../../content_option";
import Reveal from "../../components/reveal";

export const Experience = () => {
  return (
    <section id="experience" className="About-header">
      <Container>
        <Row className="mb-4 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">Experience</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <Row>
          <Col lg="11">
            <div className="exp_timeline">
              {experience.map((data, i) => (
                <Reveal key={i} delay={i * 90} className="exp_item">
                  <span className="exp_node" />
                  <div className="exp_card glass">
                    <h5 className="exp_title">{data.title}</h5>
                    <ul className="exp_points">
                      <li>{data.description1}</li>
                      <li>{data.description2}</li>
                      <li>{data.description3}</li>
                    </ul>
                  </div>
                </Reveal>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
